import(/* webpackMode: "eager" */ "/vercel/path0/dashboard/app/global-error.tsx");
